import React, { useCallback, useRef } from 'react';

import VideoOffIcon from '../../../icons/VideoOffIcon';
import VideoOnIcon from '../../../icons/VideoOnIcon';

import useDevices from '../../../hooks/useDevices/useDevices';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';
import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

export default function RoomToggleVideoButton(props: { disabled?: boolean; className?: string }) {
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const lastClickTimeRef = useRef(0);
  const { hasVideoInputDevices } = useDevices();

  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [toggleVideoEnabled]);

  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  return (
    <IconButton
      style={{ width: '48px', height: '48px', border: `solid 1px ${primaryColor}` }}
      className={props.className}
      onClick={toggleVideo}
      disabled={!hasVideoInputDevices || props.disabled}
    >
      {isVideoEnabled ? <VideoOnIcon color={primaryColor} /> : <VideoOffIcon color={primaryColor} />}
    </IconButton>
  );
}
